const merge = require('merge-options');
const { error } = require('./notifications');

export const remote = {
  fetch(url, opts) {
    let apiUrl = '/api/v1' + url;

    return fetch(apiUrl, _apiRequestOptions(opts))
      .then(_parseJSONAndStatus);
  },

  del(url) {
    return remote.fetch(url, {
      method: 'DELETE',
    });
  },

  get(url) {
    return remote.fetch(url);
  },

  patch(url, data) {
    return remote.fetch(url, {
      body: JSON.stringify(data),
      method: 'PATCH',
    });
  },

  post(url, data) {
    return remote.fetch(url, {
      body: JSON.stringify(data),
      method: 'POST',
    });
  },

  put(url, data) {
    return remote.fetch(url, {
      body: JSON.stringify(data),
      method: 'PUT',
    });
  },
};

function _apiRequestOptions(opts) {
  let defaults = {
    credentials: 'include',
    headers: {
      'Accept': 'application/json',
      'Content-Type': 'application/json',
    },
  };

  return merge(defaults, opts);
}

function _parseJSONAndStatus(res) {
  let httpStatus = res.status;
  let contentType = res.headers.get('content-type');

  // Just return response for non-JSON requests
  if (!contentType || !contentType.includes('application/json')) {
    return res;
  }

  return res.text()
    .then(responseBody => {
      let json = responseBody;

      if (contentType && contentType.includes('json') && httpStatus !== 204 && responseBody.length > 0) {
        try {
          json = JSON.parse(responseBody);
        } catch(e) {
          return Promise.reject(new TypeError(`Invalid json res body: '${responseBody}' reason: '${e.message}'`));
        }
      }

      if (httpStatus >= 200 && httpStatus < 300) {
        return json;
      } else if (httpStatus === 401) {
        // Redirect to login
        location.href = '/login';
        return;
      } else {
        let errorMessage = res.statusText;

        if (json.errors && json.errors[0]) {
          errorMessage = json.errors[0].title || json.errors[0].detail;
        }

        let err = new Error(httpStatus + ': ' + errorMessage);

        // Show UI error
        error(err.message);

        return Promise.reject(err);
      }
    });
}

// parseUri 1.2.2
// (c) Steven Levithan <stevenlevithan.com>
// MIT License
// @link http://blog.stevenlevithan.com/archives/parseuri
export function parseUri(str) {
  var o   = parseUri.options,
    m   = o.parser[o.strictMode ? 'strict' : 'loose'].exec(str),
    uri = {},
    i   = 14;

  while (i--) uri[o.key[i]] = m[i] || '';

  uri[o.q.name] = {};
  uri[o.key[12]].replace(o.q.parser, function ($0, $1, $2) {
    if ($1) uri[o.q.name][$1] = $2;
  });

  return uri;
}
parseUri.options = {
  strictMode: false,
  key: ['source', 'protocol', 'authority', 'userInfo', 'user', 'password', 'host', 'port', 'relative', 'path', 'directory', 'file', 'query', 'anchor'],
  q:   {
    name:   'queryKey',
    parser: /(?:^|&)([^&=]*)=?([^&]*)/g
  },
  parser: {
    // eslint-disable-next-line
    strict: /^(?:([^:\/?#]+):)?(?:\/\/((?:(([^:@]*)(?::([^:@]*))?)?@)?([^:\/?#]*)(?::(\d*))?))?((((?:[^?#\/]*\/)*)([^?#]*))(?:\?([^#]*))?(?:#(.*))?)/,
    // eslint-disable-next-line
    loose:  /^(?:(?![^:@]+:[^:@\/]*@)([^:\/?#.]+):)?(?:\/\/)?((?:(([^:@]*)(?::([^:@]*))?)?@)?([^:\/?#]*)(?::(\d*))?)(((\/(?:[^?#](?![^?#\/]*\.[^?#\/.]+(?:[?#]|$)))*\/?)?([^?#\/]*))(?:\?([^#]*))?(?:#(.*))?)/
  }
};

export function getQueryStringParam(name, defaultValue) {
  const urlParts = parseUri(location.href);

  return urlParts.queryKey[name] || defaultValue;
}
